import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface SectionHeaderTextProps {
  title?: string;
  className?: string;
  children?: ReactNode;
}

export function SectionHeaderText({
  title,
  className = '',
  children,
}: SectionHeaderTextProps) {
  return (
    <div
      className={`text-xs text-muted-foreground font-medium px-6 mb-3 ${className}`}
    >
      {children || title}
    </div>
  );
}

interface SectionHeaderProps {
  title: string;
  className?: string;
  children?: ReactNode;
}

export function SectionHeader({
  title,
  className = '',
  children,
}: SectionHeaderProps) {
  return (
    <div className={cn('mt-9 ', className)}>
      <SectionHeaderText className="relative z-2 " title={title} />
      {children}
    </div>
  );
}
